var map = {
	"./Tracks-Italic.eot": 26,
	"./Tracks-Italic.svg": 27,
	"./Tracks-Italic.ttf": 28,
	"./Tracks-Italic.woff": 29,
	"./Tracks-Italic.woff2": 30,
	"./Tracks-Normal.eot": 31,
	"./Tracks-Normal.svg": 32,
	"./Tracks-Normal.ttf": 33,
	"./Tracks-Normal.woff": 34,
	"./Tracks-Normal.woff2": 35,
	"./open-sans-bold.eot": 36,
	"./open-sans-bold.svg": 37,
	"./open-sans-bold.ttf": 38,
	"./open-sans-bold.woff": 39,
	"./open-sans-bold.woff2": 40,
	"./open-sans-regular.eot": 41,
	"./open-sans-regular.svg": 42,
	"./open-sans-regular.ttf": 43,
	"./open-sans-regular.woff": 44,
	"./open-sans-regular.woff2": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;